import { valueIsDefined } from "@legacy/core/utils/utils"
import clsx from "clsx"

import Skeleton from "@particles/Skeleton/Skeleton"

import { Icon, IconButton } from "@atoms"

import styles from "./ValueDisplay.module.scss"
import type { ValueDisplayProps } from "./ValueDisplay.types"

export default function ValueDisplay(props: ValueDisplayProps) {
    const {
        className,
        variant = "vertical",
        label,
        showLabel = true,
        value,
        icon,
        showIcon = true,
        isLoading = false,
    } = props

    const renderedValue = value ?? "\u2014" // em dash as placeholder

    if (variant === "horizontal") {
        return (
            <div className={clsx(styles.base, styles.horizontal, className)}>
                {showLabel && (
                    <div className={styles.label} title={typeof label === "string" ? label : undefined}>
                        {label}
                    </div>
                )}
                <div className={styles.valueRow}>
                    {isLoading ? (
                        <Skeleton width={112} height={10} borderRadius={0} />
                    ) : (
                        <>
                            {showIcon && icon && <Icon icon={icon} size={14} className={styles.icon} />}
                            <div
                                className={clsx(styles.value, !value && styles.placeholderValue)}
                                title={typeof renderedValue === "string" ? renderedValue : undefined}
                            >
                                {renderedValue}
                            </div>
                        </>
                    )}
                </div>
            </div>
        )
    } else {
        const { actionButtons } = props

        return (
            <div className={clsx(styles.base, styles.vertical, className)}>
                <div className={styles.labelAndValue}>
                    {showLabel && (
                        <div className={styles.label} title={typeof label === "string" ? label : undefined}>
                            {label}
                        </div>
                    )}
                    <div className={styles.valueRow}>
                        {isLoading ? (
                            <Skeleton width={"100%"} height={10} borderRadius={0} />
                        ) : (
                            <>
                                {showIcon && icon && <Icon icon={icon} size={14} className={styles.icon} />}
                                <div
                                    className={clsx(styles.value, !valueIsDefined(value) && styles.placeholderValue)}
                                    title={typeof renderedValue === "string" ? renderedValue : undefined}
                                >
                                    {renderedValue}
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {Array.isArray(actionButtons) && actionButtons.length > 0 && (
                    <div className={styles.actionsButtons}>
                        {actionButtons.slice(0, 3).map((btnProps, index) => (
                            <IconButton key={`action_button_${index}`} {...btnProps} size="lg" variant="ghost" />
                        ))}
                    </div>
                )}
            </div>
        )
    }
}
